import { useEffect, useState } from "react"
import { getTokenLocal } from "../../../../helper/utils"
import { useResponseHandle } from "../../../hooks"
import { useNavigate } from "react-router-dom"
import MetricAPI from "../../../../api/metric"
import CloseIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material"
import { useDispatch } from "react-redux"
import { setNewUserPractices } from "../../../redux/slices/usersSlice"
import { useSelector } from "react-redux"
import UserAPI from "../../../../api/user"

const userAPI = new UserAPI()
const metricAPI = new MetricAPI()

const AddNewGroupDetail = (props: any) => {
  const dispatch = useDispatch()
  const token = getTokenLocal()
  const navigate = useNavigate()
  const {
    open,
    setOpen,
    fetchUserDetails,
    isNewOffice,
    groupSk,
    uid,
    isNewOfficeManagerGroup,
    multiple,
  } = props
  const [selectedValue, setSelectedValue] = useState<any>([])
  const [selectedOffices, setSelectedOffices] = useState<any>([])
  const [isPracticesLoading, setIsPracticesLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const newUserGroups = useSelector((state: any) => {
    return state.users.newUserGroups
  })
  const [newPractices, setNewPractices] = useState<any>([])

  const newUserPractices = useSelector((state: any) => {
    return state.users.newUserPractices
  })

  useEffect(() => {
    if (isNewOffice) {
      getPratices()
    }
  }, [isNewOffice])

  const handleSelectGroup = (
    event: SelectChangeEvent<string>,
    child: any,
    isOffice?: boolean,
  ) => {
    setSelectedValue([event.target.value])
  }

  const handleChange = (
    event: SelectChangeEvent<string>,
    child: any,
    isOffice?: boolean,
  ) => {
    newPractices.length && setNewPractices([])
    if (isOffice || isNewOffice) {
      const value = child.props.value
      setSelectedOffices((prevSelectedOffices: any) => {
        const index = prevSelectedOffices.indexOf(value)
        if (index === -1) {
          return [...prevSelectedOffices, value]
        } else {
          return prevSelectedOffices.filter((item: string) => item !== value)
        }
      })
    } else if (!isNewOffice && !isNewOfficeManagerGroup) {
      const value = child.props.value
      setSelectedValue((prevSelectedValue: any) => {
        const index = prevSelectedValue.indexOf(value)
        if (index === -1) {
          return [...prevSelectedValue, value]
        } else {
          return prevSelectedValue.filter((item: string) => item !== value)
        }
      })
    } else {
      setSelectedValue(event.target.value as string)
      isNewOfficeManagerGroup && getPratices(event.target.value)
      isNewOfficeManagerGroup && setSelectedOffices([])
    }
  }

  const renderSelectedGroups = (list: any, placeHolder: any) => {
    if (!list) {
      return placeHolder
    }

    return list
  }

  const getPratices = async (sk?: string | any) => {
    setIsPracticesLoading(true)
    if (token) {
      const response = await metricAPI.getMetricPracticesByGroups(
        token as string,
        sk ? [sk] : [groupSk],
      )
      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        dispatch(setNewUserPractices(result?.data))
        setNewPractices(result?.data)
      } else {
        navigate("/auth")
      }
      setIsPracticesLoading(false)
    }
  }

  const handleSubmit = async () => {
    setIsLoading(true)

    const response = await userAPI.updateGroupDetails(
      token,
      isNewOffice ? [groupSk] : selectedValue,
      isNewOffice || isNewOfficeManagerGroup ? selectedOffices : [],
      uid,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      fetchUserDetails()
      setSelectedOffices([])
      setSelectedValue([])
      setIsLoading(false)
      setOpen(false)
    } else {
      setIsLoading(false)
      navigate("/auth")
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle
        sx={{
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "1rem",
          display: "flex ",
          justifyContent: "space-between",
        }}
      >
        Assign{" "}
        {isNewOffice
          ? "Offices"
          : isNewOfficeManagerGroup
          ? "Offices"
          : "Groups"}
        <IconButton sx={{ mr: 1 }} onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>{" "}
      <DialogContent sx={{ borderBottom: "1px solid #e0e0e0", width: "500px" }}>
        <DialogContentText sx={{ marginBottom: "10px" }}>
          Select {isNewOffice ? "offices" : "a group"} to{" "}
          {isNewOfficeManagerGroup ? "proceed" : "be assigned"}
        </DialogContentText>

        {!isNewOfficeManagerGroup && // when multiple groups and practices are required to be selected
          (multiple ? (
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple={multiple}
              renderValue={(selected) => {
                if (!multiple && selected) {
                  return selected.group_name
                }

                if (!isNewOfficeManagerGroup && selected) {
                  return (
                    selected
                      .map((itemSk: any) => {
                        const selectedItem = !isNewOffice
                          ? newUserGroups.find(
                              (item: { group_sk: any }) =>
                                item.group_sk === itemSk,
                            )
                          : newUserPractices.find(
                              (item: { practice_sk: any }) =>
                                item.practice_sk === itemSk,
                            )
                        return selectedItem
                          ? isNewOffice
                            ? selectedItem.name
                            : selectedItem.group_name
                          : ""
                      })
                      .join(", ") || "" // Placeholder when no option is selected
                  )
                }
              }}
              value={isNewOffice ? selectedOffices : selectedValue}
              onChange={(e, child) => handleChange(e, child)}
              fullWidth
              inputProps={{ "aria-label": "Without label" }}
              displayEmpty // Allow the Select component to display empty when no option is selected
            >
              {isNewOffice
                ? !isPracticesLoading &&
                  newUserPractices?.map((item: any) => (
                    <MenuItem key={item.practice_sk} value={item.practice_sk}>
                      <Checkbox
                        checked={selectedOffices?.includes(item.practice_sk)}
                      />
                      {item.name}
                    </MenuItem>
                  ))
                : newUserGroups?.map((item: any) =>
                    multiple ? (
                      <MenuItem key={item.group_sk} value={item.group_sk}>
                        <Checkbox
                          checked={selectedValue?.includes(item.group_sk)}
                        />
                        {item.group_name}
                      </MenuItem>
                    ) : (
                      <MenuItem key={item.group_sk} value={item.group_sk}>
                        {item.group_name}
                      </MenuItem>
                    ),
                  )}
            </Select>
          ) : (
            <Select
              labelId="demo-single-name-label"
              id="demo-single-name"
              fullWidth
              onChange={(e: any, child) => handleSelectGroup(e, child)}
            >
              {newUserGroups?.map((item: any) => (
                <MenuItem key={item.group_sk} value={item.group_sk}>
                  {item.group_name}
                </MenuItem>
              ))}
            </Select>
          ))}

        {!isNewOffice &&
          isNewOfficeManagerGroup && ( // when office manager needs to select a single group first
            <Select
              value={selectedValue[0]}
              onChange={(e, child) => handleChange(e, child)}
              fullWidth
              inputProps={{ "aria-label": "Without label" }}
              displayEmpty // Allow the Select component to display empty when no option is selected
            >
              {newUserGroups?.map((item: any) => (
                <MenuItem key={item.group_sk} value={item.group_sk}>
                  {item.group_name}
                </MenuItem>
              ))}
            </Select>
          )}

        {isNewOfficeManagerGroup && ( // when office manager needs to select multiple offices after group
          <>
            <DialogContentText sx={{ margin: "20px 0  10px 0" }}>
              Select offices to be assigned
            </DialogContentText>
            <Select
              renderValue={
                (selected) =>
                  (selected &&
                    selected
                      .map((itemSk: any) => {
                        const selectedItem = newUserPractices.find(
                          (item: { practice_sk: any }) =>
                            item.practice_sk === itemSk,
                        )
                        return selectedItem ? selectedItem.name : ""
                      })
                      .join(", ")) ||
                  "" // Placeholder text when nothing is selected
              }
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple={true}
              value={selectedOffices}
              onChange={(e, child) => handleChange(e, child, true)}
              fullWidth
              disabled={
                isPracticesLoading ||
                newUserPractices?.length === 0 ||
                selectedValue?.length === 0
              }
              inputProps={{ "aria-label": "Without label" }}
              displayEmpty // Allow the Select component to display empty when no option is selected
            >
              {!isPracticesLoading &&
                newUserPractices?.map((item: any) => (
                  <MenuItem key={item.practice_sk} value={item.practice_sk}>
                    <Checkbox
                      checked={selectedOffices?.includes(item.practice_sk)}
                    />
                    {item.name}
                  </MenuItem>
                ))}
            </Select>
          </>
        )}
      </DialogContent>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          padding: "20px",
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={() => setOpen(false)}
          sx={{ width: "fit-content", minWidth: "40px", paddingX: "40px" }}
        >
          Cancel
        </Button>
        <Button
          disabled={
            isLoading ||
            (isNewOfficeManagerGroup && selectedOffices?.length === 0)
          }
          variant="contained"
          fullWidth
          onClick={handleSubmit}
          sx={{ width: "fit-content", minWidth: "40px", paddingX: "40px" }}
          startIcon={isLoading && <CircularProgress size="1.5rem" />}
        >
          Assign
        </Button>
      </Box>
    </Dialog>
  )
}

export default AddNewGroupDetail
